export const PROFILE_ROUTE_NAME = 'profile' as const

export const PROFILE_TAB = {
  general: 'general',
  password: 'password',
  '2fa': '2fa',
  contacts: 'contacts'
} as const

export type ProfileTabId = (typeof PROFILE_TAB)[keyof typeof PROFILE_TAB]

export const PROFILE_TABS = [
  { id: PROFILE_TAB.general, label: 'General', testId: 'profile-tab-general' },
  { id: PROFILE_TAB.password, label: 'Update Password', testId: 'profile-tab-password' },
  {
    id: PROFILE_TAB['2fa'],
    label: 'Two-Factor Authentication',
    testId: 'profile-tab-2fa'
  },
  { id: PROFILE_TAB.contacts, label: 'Contacts', testId: 'profile-tab-contacts' }
] as const

export const PROFILE_TEST_IDS = {
  page: 'profile-page',
  generalTab: 'profile-general-tab',
  passwordTab: 'profile-password-tab',
  twoFactorTab: 'profile-2fa-tab',
  contactsTab: 'profile-contacts-tab',
  notificationsTab: 'profile-notifications-tab',
  notificationsSoundToggle: 'profile-notifications-sound-toggle',
  googleConnect: 'profile-google-connect',
  googleDisconnect: 'profile-google-disconnect',
  microsoftConnect: 'profile-microsoft-connect',
  microsoftDisconnect: 'profile-microsoft-disconnect'
} as const
